import { Box } from '@creditas-ui/layout';
import { Typography } from '@creditas-ui/typography';
import { InputOpened } from '@creditas-ui/input';
import { StepLayout } from '../../../components/StepLayout';
import { useWizard } from '../../../components/StepWizard';
import { usePhoneStep } from './usePhoneStep';
import i18n from '../../../i18n';
import { FlowTypes } from '../enums/FlowTypes';

type PhoneStepProps = {
  flowType?: FlowTypes;
  showBack?: boolean;
};

const HelperText = (): JSX.Element => (
  <Box width="249px">
    <Typography color="neutral.60" variant="bodySmRegular">
      {i18n.t('flows:add_phone.phone_step.helper_text')}
    </Typography>
  </Box>
);

const PhoneStep = ({
  flowType = FlowTypes.CELLPHONE,
  showBack = true,
}: PhoneStepProps): JSX.Element => {
  const { hasPrev } = useWizard();
  const { handleChange, handleSubmit, isValid, phone, errorMessage } = usePhoneStep(flowType);

  return (
    <StepLayout
      showBack={hasPrev && showBack}
      handleSubmit={handleSubmit}
      isValid={isValid}
      helperText={<HelperText />}
    >
      <Box marginTop="8px" marginBottom="35px" height="auto">
        <Typography
          color="neutral.90"
          variant={{
            _: 'bodyLGRegular',
            '5xl': 'headingSmRegular',
          }}
        >
          {i18n.t('flows:add_phone.phone_step.title')}
        </Typography>
      </Box>

      <Box height="auto">
        <form onSubmit={handleSubmit}>
          <InputOpened
            data-testid="input-phone"
            enterKeyHint="send"
            placeholder={i18n.t('flows:add_phone.phone_step.label')}
            onChange={handleChange}
            value={phone}
            adornmentLeft="+55"
          />
        </form>
      </Box>

      {errorMessage && (
        <Typography color="error.60" variant={{ _: 'bodySmRegular', '5xl': 'bodyMdRegular' }}>
          {errorMessage}
        </Typography>
      )}
    </StepLayout>
  );
};

export { PhoneStep };
